/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventAdminModel } from './EventAdminModel';
import {
    EventAdminModelFromJSON,
    EventAdminModelFromJSONTyped,
    EventAdminModelToJSON,
} from './EventAdminModel';

/**
 *
 * @export
 * @interface ListEventAdminResponse
 */
export interface ListEventAdminResponse {
    /**
     *
     * @type {number}
     * @memberof ListEventAdminResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListEventAdminResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListEventAdminResponse
     */
    total: number;
    /**
     *
     * @type {Array<EventAdminModel>}
     * @memberof ListEventAdminResponse
     */
    events: Array<EventAdminModel>;
}

/**
 * Check if a given object implements the ListEventAdminResponse interface.
 */
export function instanceOfListEventAdminResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('events' in value)) return false;
    return true;
}

export function ListEventAdminResponseFromJSON(json: any): ListEventAdminResponse {
    return ListEventAdminResponseFromJSONTyped(json, false);
}

export function ListEventAdminResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListEventAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        events: (json['events'] as Array<any>).map(EventAdminModelFromJSON),
    };
}

export function ListEventAdminResponseToJSON(value?: ListEventAdminResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        events: (value['events'] as Array<any>).map(EventAdminModelToJSON),
    };
}
